module.exports = __webpack_public_path__ + "img/swiper_06.bd51699c.jpg";